import { http } from "@/utils/http";
export const pointProduct = (params) => {
  // 获取游戏点数
  return http({ url: `/1/pointproducts`, method: "get", params: params });
};
export const propProduction = (params) => {
  //获取元宝
  return http({ url: `/1/propproducts`, method: "get", params: params });
};
export const rechargeRecord = (params) => {
  // 获取充值列表
  return http({ url: `/1/rechargerecords`, method: "get", params: params });
};
export const getRechargeDetail = (params) => {
  // 获取充值详情
  return http({ url: `/1/rechargerecords?id=${params.id}`, method: "get" });
};
export const propRecord = (params) => {
  // 获取消费记录
  return http({
    url: `/1/proprecords`,
    method: "get",
    params: params,
  });
};
